

export class BiomeUtil {
    biomes = [
      { inputId: "AMAZONIA", label: "AMAZONIA" },
      { inputId: "CAATINGA", label: "CAATINGA" },
      { inputId: "CERRADO", label: "CERRADO" },
      { inputId: "PANTANAL", label: "PANTANAL" },
      { inputId: "MATA_ATRANTICA", label: "MATA ATLÂNTICA" },
      { inputId: "PAMPA", label: "PAMPA" }
    ];
  }